export default (
  {
    title = '',
    suggestedMax = null,
    maxTicksLimit = 6,
    usePercent = false,
  }
) => {
  return {
    maintainAspectRatio: false,
    plugins: {
      title: {
        display: title !== '',
        text: title,
        align: 'start',
      },
      legend: {
        align: 'end',
        labels: {
          usePointStyle: true,
          pointStyle: 'circle',
          boxWidth: 9,
          boxHeight: 9,
          padding: 15,
        },
      },
    },
    scales: {
      x: {
        gridLines: {
          display: false,
          drawBorder: false,
        },
      },
      y: {
        suggestedMax: suggestedMax,
        ticks: {
          // alignment: 'start',
          // crossAlignment: 'far',
          maxTicksLimit: maxTicksLimit,
          callback: function (value) {
            if (usePercent) {
              return (value / this.max * 100).toFixed(0) + '%'; // convert it to percentage
            }

            return value;
          },
        },
        gridLines: {
          borderDash: [1, 1],
          drawBorder: false,
        },
      },
    },
  }
};
